import * as React from "react"
import { t } from 'i18next'
import { Pager } from "../../wordpress/types_and_parser/extra_types.mod"

type PaginationState = {}
type PaginationProps = {
  pager: Pager
  setPage: (page: number) => void
}

export class Pagination extends React.Component<PaginationProps, PaginationState> {

  constructor(props) {
    super(props)
  }

  render() {
    let paginationNumbers = [];

    for (let pageNumber = this.props.pager.current_page - 4; pageNumber < this.props.pager.current_page + 5; pageNumber++) {
      if (pageNumber == this.props.pager.current_page)
        paginationNumbers.push(<li className="pages__item" key={`page-${pageNumber}`}><span className="pages__link pages__link--current">{pageNumber + 1}</span></li>);
      else if (pageNumber >= 0 && pageNumber < this.props.pager.total_pages)
        paginationNumbers.push(<li className="pages__item" key={`page-${pageNumber}`}>
          <button 
            className="pages__link" 
            onClick={() => {
              window.scrollTo(0, 0)
              this.props.setPage(pageNumber)
            }}
          >{pageNumber + 1}</button>
        </li>)
    }
  
    return this.props.pager.total_pages > 1 ? (
      <nav className="pagination">
        <div className="pagination__inner container--xl ">
          <ul className="pagination__list">
            <li className="pagination__item pagination__item--prev">
              <button 
                className="pagination__button pagination__button--prev link--primary" 
                disabled={this.props.pager.current_page > 0 ? false : true}
                onClick={() => {
                  window.scrollTo(0, 0)
                  this.props.setPage(this.props.pager.current_page -1) 
                }} 
              >{ t('pagination.previous') }</button>
            </li>
            {this.props.pager.current_page > 4 ? 
              <li className="pagination__item">
                <button 
                  className="pagination__button" 
                  onClick={() => {
                    window.scrollTo(0, 0)
                    this.props.setPage(0)
                  }}
                >1</button>
              </li>
            : null }

            {this.props.pager.current_page > 5 ? 
              <li className="pagination__item pagination__item--spacer">...</li> 
            : null }
            <li className="pagination__item pages">
              <ul className="pages__list" >
                {paginationNumbers}
              </ul>
            </li>

            {this.props.pager.current_page < this.props.pager.total_pages - 6 ? 
              <li className="pagination__item pagination__item--spacer">...</li> 
            : null }
            {this.props.pager.current_page < this.props.pager.total_pages - 5 ?
              <li className="pagination__item">
                <button 
                  className="pagination__button" 
                  onClick={() => {
                    window.scrollTo(0, 0)
                    this.props.setPage(this.props.pager.total_pages - 1)
                  }}
                >{this.props.pager.total_pages}</button>
              </li>
            : null }
            <li className="pagination__item pagination__item--next">
              <button 
                className="pagination__button pagination__button--next  link--primary" 
                disabled={this.props.pager.current_page < this.props.pager.total_pages - 1 ? false : true}
                onClick={() => {
                  window.scrollTo(0, 0)
                  this.props.setPage(this.props.pager.current_page + 1)
                }}
              >{ t('pagination.next') }</button>
            </li>
          </ul>
        </div>
      </nav>
    ) : null
  }
}


// WEBPACK FOOTER //
// ./Client/components/public_site/templates/pagination.mod.tsx